import { ActionTypes } from '../constants/index';

export const getPostDetailReportedUserInfo = (payload: any) => ({
  type: ActionTypes.POST_DETAIL_REPORTED_USER_INFO_REQUEST,
  payload,
});
